module.exports = __webpack_public_path__ + "og-home.jpeg";